module.exports = __webpack_public_path__ + "img/jhuizhang.d49fe310.gif";